import { HeaderImageMapType } from './types';

export const IMAGES_MAP: HeaderImageMapType = {
  headerOne: {
    alt: 'Man laughing while listening to podcast on his iPhone',
    anchorPosition: 'left: 0;',
    fallbackExtension: 'jpg',
    imagePath: '/span/header-man-laughing',
    size: 200,
  },
  headerTwo: {
    alt: 'Two individuals smiling while recording tracks for a podcast',
    anchorPosition: 'right: 0;',
    fallbackExtension: 'jpg',
    imagePath: '/span/header-couple-using-microphones',
    size: 200,
  },
  headerThree: {
    alt: 'Man recording a new track for into a microphone for a podcast',
    anchorPosition: 'left: 0;',
    fallbackExtension: 'jpg',
    imagePath: '/span/header-man-speaking-into-microphone',
    size: 160,
  },
  headerFour: {
    alt: 'Man holding a microphone as he prepares to respond on a podcast',
    anchorPosition: 'left: 50%; transform: translateX(-50%); margin-top: 50%;',
    fallbackExtension: 'jpg',
    imagePath: '/span/header-man-with-microphone',
    size: 200,
  },
  headerFive: {
    alt: 'Two individuals listening to a podcast and reacting to the content',
    anchorPosition: 'right: 0;',
    fallbackExtension: 'jpg',
    imagePath: '/span/header-couple-listening-with-headphones',
    size: 160,
  },
};
